import React from 'react';
import PropTypes from 'prop-types';
import {
  CircularProgress,
  DialogContent,
  Dialog,
  DialogTitle,
} from '@material-ui/core';

LoadingDialog.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

// isLoading props is required
export default function LoadingDialog({ isLoading }) {
  return (
    <Dialog open={isLoading}>
      <DialogTitle id="simple-dialog-title">
        Aguarde alguns instantes
      </DialogTitle>
      <DialogContent style={{ minHeight: '100px', textAlign: 'center' }}>
        <CircularProgress disableShrink />
      </DialogContent>
    </Dialog>
  );
}
